import { Box, Breadcrumbs, Typography, Link } from '@mui/material'
import { Outlet, Link as RouterLink } from 'react-router-dom'
import { DrawerComponent } from 'Features/Projects/Scenarios/EditSettings/DrawerComponent'
import { memo } from 'react'
import { SettingsProvider } from 'Features/Projects/Scenarios/EditSettings/SettingsProvider'
import useReactRouterBreadcrumbs from 'use-react-router-breadcrumbs'
import { breadcrumbRoutes } from 'Features/App/routes'

const BreadCrumbs = () => {
  const breadcrumbs = useReactRouterBreadcrumbs(breadcrumbRoutes)

  return (
    <Box
      display="flex"
      sx={(theme) => ({
        padding: '24px 36px 12px 36px',
      })}
    >
      <Breadcrumbs aria-label="breadcrumb">
        {breadcrumbs.map(({ match, breadcrumb }, index) => {
          if (!breadcrumb) return null
          const isLast = index === breadcrumbs.length - 1

          return isLast ? (
            <Typography
              key={match.pathname}
              sx={(theme) => ({
                color: theme.palette.primary.main,
              })}
            >
              {breadcrumb}
            </Typography>
          ) : (
            <Link
              key={match.pathname}
              component={RouterLink}
              underline="hover"
              to={match.pathname}
              sx={(theme) => ({
                color: theme.palette.primary.main,
              })}
            >
              {breadcrumb}
            </Link>
          )
        })}
      </Breadcrumbs>
    </Box>
  )
}

export const EditSettingsView = memo(() => {
  const EditSettings = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          flex: 'auto',
        }}
      >
        <Box display="flex" flexDirection="column" height="100%">
          <DrawerComponent open={true} />
        </Box>
        <Box display="flex" flexDirection="column" flex="auto">
          <BreadCrumbs />
          <Outlet />
        </Box>
      </Box>
    )
  }

  return (
    <SettingsProvider>
      <EditSettings />
    </SettingsProvider>
  )
})
